<template>
  <div class="custom-tabs fw-bold mb-4">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      class="tab-btn"
      :class="{ active: modelValue === tab.value }"
      :disabled="tab.disabled"
      @click="!tab.disabled && $emit('update:modelValue', tab.value)"
      type="button"
    >
      <slot :tab="tab" name="tab-label" v-bind="tab">
        {{ tab.label }}
      </slot>
    </button>
  </div>
</template>

<script>
export default {
  name: "CustomTabs",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      required: true,
    },
  },
};
</script>
